export default function IconFile({ color = "white" }) {
  return (
    <div className="icon">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M7 0H2V16H14V7H7V0Z" fill={color} />
        <path d="M9 0V5H14L9 0Z" fill={color} />
      </svg>
    </div>
  );
}
